import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule, NO_ERRORS_SCHEMA, Type } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MapDirectivesModule } from "@directives/_map/_map.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { providerCreator } from "@services/_services.module";
import { AudioService } from "@services/audio.service";
import { ChartService } from "@services/charts.service";
import { ReeferDetailComponent } from "@temperature/_components/reefer-detail/reefer-detail.component";
import { ReeferListComponent } from "@temperature/_components/reefer-list/reefer-list.component";
import { TemperatureSourceDataComponent } from "@temperature/_components/temperature-source-data/temperature-source-data.component";
import { TemperatureTrendComponent } from "@temperature/_components/temperature-trend/temperature-trend.component";
import { TemperatureGraphComponent2 } from "@temperature/_components/tempGraph/temperature-graph.component";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { InputListComponent } from "./_components/compliance/input-list/input-list.component";
import { ProbeDetailComponent } from "./_components/compliance/probe-detail/probe-detail.component";
import { StackedProbeReadingComponent } from "./_components/compliance/stacked-probe-reading/stacked-probe-reading.component";
import { TemperatureComplianceDetailComponent } from "./_components/compliance/temperature-compliance-detail/temperature-compliance-detail.component";
import { TemperatureComplianceComponent } from "./_components/compliance/temperature-compliance/temperature-compliance.component";
import { TemperatureLogComponent } from "./_components/compliance/temperature-log/temperature-log.component";
import { ReeferErrorListComponent } from "./_components/reefer-error-list/reefer-error-list.component";
import { ZoneDetailPageComponent } from "./_components/zone/zone-detail-page/zone-detail-page.component";
import { ZoneOverviewPageComponent } from "./_components/zone/zone-overview-page/zone-overview-page.component";
import { ZoneSetPointComponent } from "./_components/zone/zone-setpoint/zone-setpoint.component";
import { ZoneSummaryViewComponent } from "./_components/zone/zone-summary-view/zone-summary-view.component";
import { ZoneTemperatureComponent } from "./_components/zone/zone-temperature/zone-temperature.component";
import { ZonedTemperatureDetailComponent } from "./_components/zone/zoned-temperature-detail/zoned-temperature-detail.component";
import { ZoneOperatingModeWidget } from "./_components/zone/zoneOperatingModeWidget/zone-operating-mode-widget.component";
import { SiteSearchComponent } from "@app/main/navigation/site-search/site-search.component";
import { GroupsModule } from "@app/main/components/resourceManagement/groups/groups.module";

const privateComponents: Type<any>[] = [
    ReeferListComponent,
    ReeferDetailComponent,
    ReeferErrorListComponent,

    TemperatureGraphComponent2,
    TemperatureTrendComponent,
    TemperatureSourceDataComponent,
    TemperatureComplianceComponent,
    TemperatureComplianceDetailComponent,

    ZonedTemperatureDetailComponent,
    ZoneOperatingModeWidget,
    ZoneSummaryViewComponent,
    ZoneDetailPageComponent,
    ZoneOverviewPageComponent,
    ZoneTemperatureComponent,
    ZoneSetPointComponent,
    ProbeDetailComponent,
    InputListComponent,
    TemperatureLogComponent,

    StackedProbeReadingComponent,

    SiteSearchComponent // temporary hack
];

const publicComponents: any[] = [

];

const declarations: Type<any>[] = [
];

const providers: any[] = [
    providerCreator(AudioService, "audioService"),
    providerCreator(ChartService, "chartService"),
];

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        BrowserAnimationsModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        PipesModule,
        ResourceFiltersDirectivesModule,
        MiscDirectivesModule,
        VehicleDirectivesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        MapDirectivesModule,
        VTableModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [NO_ERRORS_SCHEMA] //needed for highcharts
})
export class TemperatureModule {
    constructor() {
    }
}
